module.exports = __webpack_public_path__ + "static/media/idle_old.8a699b65.fbx";